/* eslint-disable import/max-dependencies */
import type { FC } from "react";
import type React from "react";
import {
  AppNavSidebar as AppNavSidebarComponent,
  AppNavSidebarMenuComponent,
  type AppNavSidebarMenuComponentUrl,
} from "@fas/cpa-cabinet-ui";
import { type Theme, Toolbar } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Assessment, Home, Star } from "@mui/icons-material";
import PostbackUrl from "../../icons/PostbackUrl";

type Props = {
  isOpen: boolean,
}

const useMenuListStyles = makeStyles((theme: Theme) => ({
  menuItem: {
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
    paddingLeft: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    "&.Mui-selected": {
      backgroundColor: "#00000014",
    },
  },
  menuItemIcon: {
    minWidth: "56px !important",
  },
  menuItemText: {
    marginTop: "4px !important",
    marginBottom: "4px !important",
  },
}));

const useDrawerStyles = makeStyles(() => ({
  paper: {
    justifyContent: "flex-start",
  },
}));

const useStyles = makeStyles((theme: Theme) => ({
  toolbar: {
    minHeight: theme.spacing(6),
  },
}));

const AppNavSidebar: FC<Props> = ({
  isOpen,
}: Props) => {
  const drawerClasses = useDrawerStyles();
  const classes = useStyles();
  const menuListClasses = useMenuListStyles();
  const links: Array<AppNavSidebarMenuComponentUrl> = [
    { url: "/dashboard", text: "Dashboard", icon: <Home /> },
    { url: "/transactionReport", text: "Transaction Report", icon: <Assessment /> },
    { url: "/activeBrands", text: "Active Brands", icon: <Star /> },
    { url: "/postbacks", text: "Postback URLs", icon: <PostbackUrl /> },
  ];

  return (
    <AppNavSidebarComponent
      permanentIconsVisible
      isOpen={isOpen}
      classes={drawerClasses}
    >
      <Toolbar className={classes.toolbar} />
      <AppNavSidebarMenuComponent links={links} classes={menuListClasses} />
    </AppNavSidebarComponent>
  );
};

export default AppNavSidebar;
